export default __webpack_public_path__ + "static/media/samuel_anoints_david.3df4a908.jpg";